import React from 'react'

import { IconProps } from './types'

const Spinner = ({ color, size, ...rest }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.99999 2V5M7.99999 11V14M3.75735 3.75736L5.87867 5.87868M10.1213 10.1213L12.2426 12.2426M1.99994 8H4.99994M11 8H14M3.75735 12.2426L5.87867 10.1213M10.1213 5.87868L12.2426 3.75736"
      stroke={color}
    />
  </svg>
)

Spinner.displayName = 'Spinner'
Spinner.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Spinner
